import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { Icon } from '../../../shared/Icon';

/**
 * VerifyingDevice component - Shows loading state while verifying device for MFA
 * Displayed between MFA method selection and verification code entry
 */
export const VerifyingDevice: React.FC = (): React.ReactElement => {
  return (
    <Container>
      <h1 style={{ margin: '.5rem 1rem' }}>Multi-Factor Authentication</h1>
      <ContentContainer>
        <SpinnerContainer>
          <Icon name='verified_user' size='large' color='#42a5f5' />
        </SpinnerContainer>
        <Message>Verifying device...</Message>
        <SubMessage>
          Please wait while we verify your authentication method
        </SubMessage>
      </ContentContainer>
    </Container>
  );
};

// Animations
const pulse = keyframes`
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
  }
`;

// Styled Components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  width: 100%;
  min-height: 200px;
`;

const SpinnerContainer = styled.div`
  animation: ${pulse} 1.5s ease-in-out infinite;
  margin-bottom: 24px;
`;

const Message = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
  margin: 0 0 8px 0;
  text-align: center;
`;

const SubMessage = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary, #666);
  margin: 0;
  text-align: center;
`;
